import alt from 'components/Dispatcher';

/**
 * Actions that affect the state of the filter word profile page itself, i.e., they do not involve
 * interaction with the server (and so there is no source).
 */
class AdminFilterWordProfilePageActions {
  constructor() {
    this.generateActions(
      'clearRecentMergedTopicId',
      'clearTopicsSelectedForMerge',
      'collapseAllDepartments',
      'expandOnlyOneDepartment',
      'markProfileEditorDirty',
      'setRecentMergedTopicId',
      'startProfileEditor',
      'stopProfileEditor',
      'toggleDepartment',
      'toggleTeam',
      'toggleTopicSelectedForMerge'
    );
  }
}

export default alt.createActions(AdminFilterWordProfilePageActions);
